import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import "./ColorPicker.css";

interface ColorPickerProps {
  currentColor: string;
  onColorChange: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  currentColor,
  onColorChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  const colors = [
    "#0099ff", // Синий (по умолчанию)
    "#ff0000", // Красный
    "#00ff00", // Зеленый
    "#ffff00", // Желтый
    "#ff00ff", // Пурпурный
    "#00ffff", // Голубой
    "#ff6600", // Оранжевый
    "#9900ff", // Фиолетовый
    "#ffffff", // Белый
    "#000000", // Черный
  ];

  return (
    <div className="color-picker">
      <button
        className="color-picker-trigger tool-btn"
        onClick={() => setIsOpen(!isOpen)}
        style={{ backgroundColor: currentColor }}
        title={t("drawing_color")}
      >
        🎨
      </button>

      {isOpen && (
        <div className="color-picker-dropdown">
          <div className="color-grid">
            {colors.map((color) => (
              <button
                key={color}
                className={`color-option ${
                  color === currentColor ? "selected" : ""
                }`}
                style={{ backgroundColor: color }}
                onClick={() => {
                  onColorChange(color);
                  setIsOpen(false);
                }}
                title={color}
              />
            ))}
          </div>
        </div>
      )}

      {isOpen && (
        <div
          className="color-picker-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ColorPicker;
